import { InjectionToken, isDevMode } from '@angular/core';

import { presentError } from './present-error';

/**
 * Whether failures are written to the console with their technical detail (URL, status, body,
 * stack). On in development builds only; a production console gets none of it. Overridden in tests.
 */
export const ERROR_LOG_ENABLED = new InjectionToken<boolean>('ERROR_LOG_ENABLED', {
  providedIn: 'root',
  factory: () => isDevMode(),
});

/**
 * Writes a failure and its technical detail to the console when `enabled`, and nothing otherwise.
 * The one place the app logs an error; the screen only ever gets `presentError(...).userKey`.
 */
export function logErrorDetail(enabled: boolean, label: string, error: unknown): void {
  if (!enabled) {
    return;
  }
  console.error(`[${label}]`, presentError(error).technical, error);
}
